import styled from 'styled-components'
import { colors } from '../../styles/styles'

export const ErrorMessage = styled.div`
  color: ${colors.error};
`
